import type { EModalName } from './modals';
import type { IStrapiImage } from './strapiImage';

export enum EScrollToElement {
  CatalogueGameList = 'catalogue_game_list',
}

export enum ELinkType {
  internal = 'internal',
  external = 'external',
  modal = 'modal',
  popup = 'popup',
}

export interface ILink {
  title?: string;
  linkType: ELinkType;
  nofollow: boolean;
  link?: string;
  scrollToElement?: EScrollToElement;
  scrollToPosition?: number;
  modal?: EModalName;
  strict?: boolean;
  isHideForGuests?: boolean;
}

export interface IImageLink {
  id: string;
  img_src: IStrapiImage;
  alt?: string;
  link?: string;
  nofollow?: boolean;
  jsLink?: boolean;
  paymentMethodsLinkId?: string;
}

export type TActionLinkExternal = {
  __component?: 'link.external';
  link: string;
  nofollow: boolean;
  title: string;
};

export type TActionLinkInternal = {
  __component?: 'link.internal';
  link: string;
  nofollow: boolean;
  title: string;
};

export type TActionLinkModal = {
  __component?: 'link.modal';
  modal: EModalName;
  optionalRedirect?: string;
  title: string;
  params: any[];
};
